<template>
  <div :class="$style.solverContainer">
    <the-sidebar @openTermsAndService="openTermsAndService"
                 @openPrivacyPolicy="openPrivacyPolicy"/>

    <div :class="$style.solverContent">
      <router-view @openTermsAndConditions="openTermsAndService"/>

      <app-iframe-dialog :value="termsAndServiceDialog"
                         iframe-src="https://eztx.com/eztx-terms-and-service/"
                         @close="closeTermsAndService" />

      <app-iframe-dialog :value="privacyPolicyDialog"
                         iframe-src="https://eztx.com/eztx-inc-digital-privacy-notice/"
                         @close="closePrivacyPolicy" />
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TheSidebar from '@/app/main/components/the-sidebar';

export default {
  data() {
    return {
      termsAndServiceDialog: false,
      privacyPolicyDialog: false,
    };
  },
  components: {
    TheSidebar,
  },
  methods: {
    ...mapActions([
      'statesRequest',
    ]),
    openTermsAndService() {
      this.termsAndServiceDialog = true;
    },
    closeTermsAndService() {
      this.termsAndServiceDialog = false;
    },
    openPrivacyPolicy() {
      this.privacyPolicyDialog = true;
    },
    closePrivacyPolicy() {
      this.privacyPolicyDialog = false;
    },
  },
  created() {
    this.statesRequest();
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.solverContainer {
  margin-left: 250px;
  display: flex;
  height: 100%;
}

.solverContent {
  flex-grow: 1;
  display: flex;
}
</style>
